






















import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop } from 'vue-property-decorator'

import YourAccountHelperComponents4AccountResourceItem from './your-account-helper-components-4-account-resource-item.vue'
import YourAccountHelperComponents5ProductResourceResourceItem from './your-account-helper-components-5-product-resource-resource-item.vue'
import YourAccountHelperComponents6JobEmploymentResourceItem from './your-account-helper-components-6-job-employment-resource-item.vue'
import YourAccountHelperComponents7CurrencyExchangeResourceItem from './your-account-helper-components-7-currency-exchange-resource-item.vue'
import YourAccountHelperComponents8DigitalCurrencyAlternativeResourceItem from './your-account-helper-components-8-digital-currency-alternative-resource-item.vue'

@Component({
  components: {
    YourAccountHelperComponents4AccountResourceItem,
    YourAccountHelperComponents5ProductResourceResourceItem,
    YourAccountHelperComponents6JobEmploymentResourceItem,
    YourAccountHelperComponents7CurrencyExchangeResourceItem,
    YourAccountHelperComponents8DigitalCurrencyAlternativeResourceItem
  }
})
class YourAccountHelperComponents3ResourceList extends Vue {
  @Prop({ default: '' }) accountId?: string
  @Prop({ default: false }) isPublicAccountViewing?: boolean
}

export default YourAccountHelperComponents3ResourceList

